module.exports = __webpack_public_path__ + "static/ical-e5fd91203f36b68c45cab6067f185507.png";